"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SharedUrls {
}
SharedUrls.FlemingWebPage = "https://www.accurx.com/video-consultation-for-nhs-trusts";
SharedUrls.ODSCodeWebPage = "https://odsportal.digital.nhs.uk/Organisation/Search";
SharedUrls.FeedbackForm = 'https://docs.google.com/forms/d/e/1FAIpQLSfRwnKJaIx4IId1SDmPePZ6jw3sgcVWoVsnHR796fCSgDJuLg/viewform?embedded=true';
SharedUrls.VideoFeedbackForm = 'https://docs.google.com/forms/d/1oMO92oxAPj_ETs0TWT8gRXcCG_UNR5qN6utliavk164/viewform?embedded=true';
SharedUrls.TriageFeedbackForm = 'https://docs.google.com/forms/d/e/1FAIpQLSch7CE7vEY9Bjx6MvLpAgZWZLKCjjivWnXghWPvTcAKOE5hTw/viewform';
SharedUrls.PifuFeedbackForm = "https://docs.google.com/forms/d/1q-Bdy6GVQdpgtES9pw4BVUlDxAcrlwgIsdqwGvceM14/viewform";
SharedUrls.PrivacyPolicy = "https://www.accurx.com/privacy-policy";
SharedUrls.PatientPrivacy = "https://www.accurx.com/patient-privacy";
SharedUrls.PatientAccurxPage = "https://www.accurx.com/patient";
SharedUrls.SecurityAndPrivacyForPatients = "https://www.accurx.com/security-and-privacy/for-patients";
SharedUrls.IsolationNote = "https://111.nhs.uk/isolation-note/";
SharedUrls.Covid19 = "https://111.nhs.uk/covid-19/";
SharedUrls.WhenTo999 = "https://www.nhs.uk/using-the-nhs/nhs-services/urgent-and-emergency-care/when-to-call-999/";
SharedUrls.ScotlandWhenTo999 = "https://www.scottishambulance.com/our-services/emergency-care/when-should-you-call-999/";
SharedUrls.WalesWhenTo999 = "https://ambulance.nhs.wales/services/learning-disabilities-zone/when-should-i-call-an-ambulance/";
SharedUrls.NorthernIrelandWhenTo999 = "https://nias.hscni.net/calling-999/";
SharedUrls.BSLVideocallTo999 = "https://999bsl.co.uk/";
SharedUrls.NHS111 = "https://111.nhs.uk/";
SharedUrls.ScotlandNHS111 = "https://www.nhs24.scot/111/";
SharedUrls.WalesNHS111 = "https://111.wales.nhs.uk/";
SharedUrls.NorthernIrelandNHS111 = "https://www.nidirect.gov.uk/articles/gp-out-hours-service";
SharedUrls.FitNote = "https://www.nhs.uk/common-health-questions/caring-carers-and-long-term-conditions/when-do-i-need-a-fit-note/";
SharedUrls.NHS = "https://www.nhs.uk/";
SharedUrls.InternalTechSlackChannel = "https://app.slack.com/client/T1U6ZF5S8/C016A7GAYCF";
SharedUrls.InternalApiDocs = "https://www.notion.so/accurx/Internal-API-36c2a26792c64387b011afc0003d4a5f";
SharedUrls.FacebookLink = "https://www.facebook.com/groups/249953093191373";
SharedUrls.TermsAndConditions = "https://www.accurx.com/terms-and-conditions";
SharedUrls.Security = "https://www.accurx.com/security";
SharedUrls.SecurityForPatients = "https://www.accurx.com/security-for-patients";
SharedUrls.Floreys = "https://www.accurx.com/floreys";
// Record View
SharedUrls.RecordViewIGInfo = "https://www.accurx.com/record-view-feature-detailed";
SharedUrls.NHSIGQuestions = "https://www.nhsx.nhs.uk/information-governance/frequently-asked-questions/";
SharedUrls.FionaCaldicottCorrespondence = "https://drive.google.com/file/d/1iDkT2PFEZV0IYfiv8eZliHfUcv3XDWmT/view";
exports.default = SharedUrls;
//# sourceMappingURL=SharedUrls.js.map